export default __webpack_public_path__ + "static/media/elevate-gry-banner-1.6bc0f9dd.jpg";